import React from 'react'
import { Box, TextBody } from '@ally/metronome-ui'
import WarningIcon from '../WarningIcon'

const MobileCardDetailFooter: React.FC<{
  message: string | null
}> = ({ message }) => {
  if (message) {
    return (
      <Box
        display="flex"
        alignItems="start"
        borderLeftStyle="solid"
        borderLeftWidth="7px"
        py="sm"
        px="xs"
        borderTop="1px solid"
        borderTopColor="slate-2"
        width="100%"
        borderBottom="1px solid"
        borderBottomColor="slate-2"
        borderRadius="0 0 4px 4px"
        data-testid="targeted-messaging"
      >
        <Box pt="2px">
          <WarningIcon />
        </Box>
        <TextBody tag="span" size="sm" weight="bold">
          {message}
        </TextBody>
      </Box>
    )
  }

  return null
}

export default MobileCardDetailFooter
